import axios from "axios";

let env:any = null;

export const getValue = (key:string, defaultValue:any = null) => {
	return env ? env[key] : defaultValue;
};

export const loadEnvironment = async () => {
	if(env){ return; }
	const http = axios.create();
	let { data } = await http.get("/config/_env.json");
	env = data;
};